export const reviewsData = [
  {
    key: "1",
    AUTHOR: "Shaun Farley",
    IMAGE: "avatar-01.jpg",
    REVIEWDATE: "24 Jan 2025",
    RATINGS: "(5.0)",
    REVIEW: "Super easy booking process and great car selection!",
  },
  {
    key: "2",
    AUTHOR: "Jenny Ellis",
    IMAGE: "avatar-12.jpg",
    REVIEWDATE: "19 Dec 2024",
    RATINGS: "(5.0)",
    REVIEW: "Transparent pricing with no hidden fees - highly recommend!",
  },
  {
    key: "3",
    AUTHOR: "Leon Baxter",
    IMAGE: "avatar-15.jpg",
    REVIEWDATE: "11 Dec 2024",
    RATINGS: "(5.0)",
    REVIEW: "Wide range of cars, from budget to luxury - perfect for any trip!",
  },
  {
    key: "4",
    AUTHOR: "Karen Flores",
    IMAGE: "avatar-17.jpg",
    REVIEWDATE: "29 Nov 2024",
    RATINGS: "(5.0)",
    REVIEW: "Pick-up and drop-off were seamless - best rental experience ever!",
  },
  {
    key: "5",
    AUTHOR: "Michael Dawson",
    IMAGE: "avatar-06.jpg",
    REVIEWDATE: "03 Nov 2024",
    RATINGS: "(5.0)",
    REVIEW: "Clean, well-maintained cars and excellent customer support",
  },
  {
    key: "6",
    AUTHOR: "Karen Galvan",
    IMAGE: "avatar-18.jpg",
    REVIEWDATE: "31 Oct 2024",
    RATINGS: "(5.0)",
    REVIEW: "Great deals and discounts - saved money on my rental!",
  },
  {
    key: "7",
    AUTHOR: "Thomas Ward",
    IMAGE: "avatar-03.jpg",
    REVIEWDATE: "15 Oct 2024",
    RATINGS: "(5.0)",
    REVIEW: "Fast check-in and check-out process, super convenient",
  },
  {
    key: "8",
    AUTHOR: "Aliza Duncan",
    IMAGE: "avatar-17.jpg",
    REVIEWDATE: "26 Sep 2024",
    RATINGS: "(5.0)",
    REVIEW: "Quick responses from customer support - very helpful",
  },
  {
    key: "9",
    AUTHOR: "James Higham",
    IMAGE: "avatar-05.jpg",
    REVIEWDATE: "01 Sep 2024",
    RATINGS: "(5.0)",
    REVIEW: "Best rental experience - I'll definitely use them again",
  },
  {
    key: "10",
    AUTHOR: "Jade Robinson",
    IMAGE: "avatar-08.jpg",
    REVIEWDATE: "15 Aug 2024",
    RATINGS: "(5.0)",
    REVIEW: "Booking was fast, and the car was ready on time!",
  },
];
